import React, { useState } from 'react';
import { Col, Row, Breadcrumb, message, Spin, Table } from 'antd';
import { fetchFrostData } from '../data/FrostApi';
import EnvironmentalForm from '../components/environmental/EnvironmentalForm';
import { environmentalColumns } from '../data/Columns';


function EnvironmentalMonitoring() {
    const [data, setData] = useState([]);
    const [formData, setFormData] = useState({ lotNumber: '', thing: '' });
    const [loading, setLoading] = useState(false);


    const handleFinish = async () => {
        setLoading(true);
        try {
            const response = await fetchFrostData(formData.thing);
            setData(response.value);
        } catch (err) {
            message.error("Could not fetch data");
        } finally {
            setLoading(false);
        }
    };

    
    return (
        <>
            <div className="breadcrumb" style={{ textAlign: 'left', marginBottom: '50px' }}>
                <h1 style={{ color: '#102F10' }}>
                    <Breadcrumb
                        items={[
                            {
                                title: <a href="/">Home</a>,
                            },
                            {
                                title: 'Environmental Monitoring',
                            },
                        ]}
                    />
                </h1>
            </div>

            <Row gutter={[32, 24]}>
                <Col xs={24}>
                    <EnvironmentalForm formname="environmental_filter" formData={formData} setFormData={setFormData} onHndleFinish={handleFinish}/>
                </Col>
                <Col xs={24}>
                    <Spin spinning={loading} size="large">
                        {environmentalColumns.length > 0 ? (
                            <Table
                                columns={environmentalColumns} // Dynamically updated columns
                                dataSource={data.map((item, index) => ({ ...item, key: `${item['@iot.id']}` }))}
                                pagination={false}
                                size="middle"
                                scroll={{ x: 800 }}
                            />
                        ) : (
                            <p>No data or columns to display</p> // Optional message when table is not rendered
                        )}
                    </Spin>
                </Col>
            </Row>            
        </>
    );
}

export default EnvironmentalMonitoring;
